import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';

import { IconComponent } from '../icon/icon.component';
import { ToastItem } from './toast-item';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  standalone: true,
  imports: [MatIconButton, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  readonly item = input.required<ToastItem>();
  readonly closed = output<void>();
}
